import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { compose } from 'ramda';
import { useSelector } from 'react-redux';

import Form from '@gef-ui/form-material/Form';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelistProvider, Dialog } from 'components';
import Panel from 'components/atoms/GefMui/Panel/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import SubmitFormDialog from 'components/atoms/GefMui/SubmitFormDialog/SubmitFormDialog';
import { codelists } from 'constants/codelists';
import MODALS from 'constants/modals';
import PAGES from 'constants/pages';
import { subheaders } from 'features/common/Subheader/constants';
import { useRenderSubheaderTitle } from 'features/common/Subheader/hooks';
import { dialogs as processInfoDialogs } from 'features/other/processInformation/constants';
import formDescriptorFn, { TASK_OVERVIEW_FORM_NAME } from 'features/views/taskOverview/form';
import { getContextUser } from 'features/views/userContext/selectors';
import TaskForwardingModal from 'pages/TaskDetail/modals/TasksForwarding/TaskForwardingModal';

import Filter from './components/Filter';
import Progress from './components/Progress';
import TaskTypeList from './components/TaskTypeList';
import Toolbar from './components/Toolbar';

// todo - localizations buttons toolbar
export const TasksOverview = ({ taskTypesCodelist = [] }) => {
	const contextUser = useSelector(getContextUser);

	const subheaderTitle = useRenderSubheaderTitle({
		contextUser,
		pageTitle: getLabelMessage('tasksOverview:tasksHeader'),
	});

	const floatingDialogs = (
		<>
			<SubmitFormDialog pageName={TASK_OVERVIEW_FORM_NAME} />
			<Dialog mui name={processInfoDialogs.userCanProcessMax10Tasks}>
				{getLabelMessage('processInformation:userCanProcessMax10Tasks')}
			</Dialog>
			<Dialog mui name={processInfoDialogs.userDoesntHavePermissions}>
				{getLabelMessage('processInformation:userDoesntHavePermissions')}
			</Dialog>
			<Progress />
		</>
	);

	return (
		<Form name={TASK_OVERVIEW_FORM_NAME} formDescriptorFn={formDescriptorFn}>
			<Panel
				screenId={PAGES.tasksOverview.id}
				screenName={PAGES.tasksOverview.name}
				floatingDialogs={floatingDialogs}
			>
				<TaskForwardingModal id={MODALS.task_forwarding} />
				<PaperWithToolbar
					subheaderTitle={subheaderTitle}
					toggledElement={<Filter />}
					toolbar={<Toolbar taskTypesCodelist={taskTypesCodelist} />}
					collapsibleProps={{ id: subheaders.tasksOverview }}
				>
					<Box sx={{ mt: 'unset !important' }}>
						<TaskTypeList taskTypesCodelist={taskTypesCodelist} />
					</Box>
				</PaperWithToolbar>
			</Panel>
		</Form>
	);
};

TasksOverview.propTypes = {
	taskTypesCodelist: PropTypes.array,
};

// prefetching for subcomponent use
export default compose(
	codelistProvider(codelists.taskTypes, 'taskTypesCodelist'),
	codelistProvider(codelists.taskSubtypes, 'taskSubtypesCodelist'),
)(TasksOverview);
